// extracted by mini-css-extract-plugin
export default {"form":"styles_form__mahPS","text":"styles_text__thxYH","resend-wrapper":"styles_resend-wrapper__iTS0Z","link":"styles_link__yPSy+","buttons":"styles_buttons__2-qCE"};